import BaseAPIService from '../base/base-api-service';
import PartReturnModel from 'src/model/partReturn.model';
import env from 'src/shared/env';

class SynonymService extends BaseAPIService<PartReturnModel> {
  public synonymEndPoint = 'navapp/v1/synonyms';
  private wpBaseURL: string = env.REACT_APP_BASE_WORDPRESS_URL;
  public wpLoginEndpoint: string = 'wp-json/custom/v1/check-admin-login';

 
  constructor() {
    super(PartReturnModel);
  }

  

  public getSynonym(): Promise<any> {
    return this.doRequest({
      baseURL: this.baseURL,
      url: `${this.synonymEndPoint}`
    }).then(res => res.data);
  }

  public fetchSynonymByTerm(term: string): Promise<any> {
    return this.doRequest({
      baseURL: this.baseURL,
      url: `${this.synonymEndPoint}/${term}`
    }).then(response => response.data);
  }

  public deleteSynonymByTerm(term: string): Promise<any> {
    return this.doRequest({
      baseURL: this.baseURL,
      method: 'delete',
      url: `${this.synonymEndPoint}/${term}`
    }).then(response => response.data);
  }

  public addSynonym(requestBody:any): Promise<any> {
    return this.doRequest({
      baseURL: this.baseURL,
      url: `${this.synonymEndPoint}`,
      method: 'put',
      data:  requestBody 
    }).then(res => res.data);
  }
}

const synonymServiceInstance = new SynonymService();
Object.freeze(synonymServiceInstance);

export default synonymServiceInstance;
